
import styled, { keyframes } from 'styled-components';
import { customProps, Flexbox } from '../../Theme/GlobalStyles';
import { globalTheme } from '../../Theme/Theme';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const PopupWrapper = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
background: linear-gradient(111deg, rgba(255, 255, 255, 0.40) -8.95%, rgba(255, 255, 255, 0.01) 114%);
backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1999;
  transition: opacity 0.4s ease-in, 
  visibility 0.4s ease-in;
  opacity: 0;
  visibility: hidden;
  animation: ${fadeIn} 0.5s linear;

  &.active {
    opacity: 1;
    visibility: visible;
  }

  .userActivepopup{
      max-width: 650px;
    }
`

const PopupBody = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    border-radius: 34px;
    border: 1px solid ${globalTheme.colors.grey2};
background: #00000080;
backdrop-filter: blur(46px);
    padding: ${props => props.padding ? `${props.padding}px` : '24px'};
    /* box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -4px rgba(0, 0, 0, 0.10); */
    max-width: ${props => props.maxWidth ? `${props.maxWidth}px` : '500px'};
    max-height: ${props => props.maxHeight ? `${props.maxHeight}px` : 'max-content'};
    width: 100%;
    overflow:auto;
    height:100%;
    position: relative;

    .closeIcon{
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
    }

    .Buttonwrapper{
      padding: 8px 12px;
      border-radius: 8px;
      background: ${globalTheme.colors.grey8};

      button{
        width: 100%;
      }
    }
    .DecreaseIcon{
      transform:rotate(180deg);
      path{
        stroke:#F04438;
      }
    }

    .ScoreTimeline{
      border-radius: 8px;
      border: 1px solid var(--Gray-Border, #F0F0F0);
      background: var(--White, #FFF);
      padding: 16px;
    }
`

const ButtonWrapper = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    margin-top: ${props => props.marginTop ? `${props.marginTop}px` : '40px'};
    gap: ${props => props.gap ? `${props.gap}px` : '6px'};
`

const TeamPopbox = styled(Flexbox).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: relative;
  padding: 24px 20px;
  border-radius: 10px 10px 0px 0px;
  border: 1px solid ${globalTheme.colors.nuetral2};

  .scrollerBox{
    max-height: 208px;
    height: 100%;
    overflow: auto;
    padding-right: 5px;
  }

  .memberBox{
    border-top: 1px solid ${globalTheme.colors.nuetral2};
    padding-top: 12px;
    margin-top: 16px;
  }
`

const MultiButtonWrap = styled.div.withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  position: relative;
  border-radius: 0px 0px 10px 10px;
  border: 1px solid ${globalTheme.colors.nuetral2};
  border-top: 0;
  width: 100%;
  padding: 14px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const PopupBodyThemed = styled(PopupBody).withConfig({ shouldForwardProp: prop => !customProps.has(prop) })`
  background: ${({ theme }) => theme.primary2};
  border-color: ${({ theme }) => theme.primary2};
`

export {
  PopupWrapper,
  PopupBody,
  ButtonWrapper,
  TeamPopbox,
  MultiButtonWrap,
  PopupBodyThemed,
};